import { useLanguage } from 'features/hooks/useLanguage';
import { LanguageType } from 'types';

export const EnableCodelistInExistingProjectsStep = () => {
	const language = useLanguage();
	const translation = DICTIONARY[language];

	return (
		<>
			<p className="text-base">{translation.description}</p>

			<img
				src="/img/codelist-changelog/enable-for-existing.gif"
				alt="Kodelister i eksisterende prosjekter"
				className="mt-6 w-full"
			/>
		</>
	);
};

const DICTIONARY = {
	[LanguageType.English]: {
		description:
			'You may enable codelists for existing projects by toggling the button in the "edit project" dialog.'
	},

	[LanguageType.Norwegian]: {
		description:
			'Du skrur på kodelister for eksisterende prosjekter ved å skru på knappen i "rediger prosjekt"-dialogen.'
	}
};
